import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { CircularProgress, styled } from "@mui/material";
import { confirmSignUp } from "user-management/src/cognito/kahunUserAuth";
import { KahunPrimaryTypography } from "fe-web-components/styles/typography";
import { UserLoginContainer } from "./userLoginContainer";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export const useQueryParams = () => new URLSearchParams(window.location.search);

//region [[ Styles ]]

const RosebudLoginContainer = styled(UserLoginContainer)({
  background: KahunColorMap.White,
  //boxShadow: "#8082827d -1px 1px 7px 1px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface VerifyCodeProps {
  onComplete: () => void;
  onLoginClick?: () => void;
  code: string;
  userName: string;
  message?: string;
  children?: React.ReactNode;
  hideLogo?: boolean;
}
//endregion [[ Props ]]

export const VerifyCodeWidget = ({
  onComplete,
  code,
  userName,
  ...props
}: VerifyCodeProps) => {
  const [error, setError] = useState("");
  const [verified, setVerified] = useState(false);
  const [verifing, setVerifing] = useState(false);
  const [expired, setExpired] = useState(false);

  const handleVerifyActivationCode = useCallback(() => {
    (async () => {
      try {
        setVerifing(true);
        await confirmSignUp(userName, code);
        setVerified(true);
        setTimeout(onComplete, 4000);
      } catch (e) {
        if (e["code"] === "ExpiredCodeException") {
          setExpired(true);
          setTimeout(onComplete, 4000);
        } else {
          setError(e["message"] || e);
          setVerifing(false);
        }
      }
    })();
  }, [onComplete, code, userName]);

  useEffect(() => handleVerifyActivationCode(), [handleVerifyActivationCode]);

  return (
    <RosebudLoginContainer error={error} hideLogo={props.hideLogo}>
      {!error || (verifing && <CircularProgress />)}
      {expired && (
        <KahunPrimaryTypography>
          The code is expired. Please login, if needed you will get a new code.
        </KahunPrimaryTypography>
      )}
      {!verified && !expired && (
        <KahunPrimaryTypography>
          Hang in there as we verify your email.
        </KahunPrimaryTypography>
      )}
      {verified && (
        <KahunPrimaryTypography>
          Thank you for verifying your email. For your security, please login
          now.
        </KahunPrimaryTypography>
      )}
    </RosebudLoginContainer>
  );
};
